import { Component } from "@angular/core";
import { Toast } from "primeng/toast";
import { NgOptimizedImage } from "@angular/common";

@Component({
	selector: "app-login-page",
	imports: [Toast, NgOptimizedImage],
	templateUrl: "./login-page.component.html",
	styleUrl: "login-page.component.scss"
})
export class LoginPageComponent {}
